import { EAbusiveReportType } from "@/types/backoffice/dto/subscriber-feedback/abusive-report-type.ts";
import { ESubscriberFeedbackFormType } from "@/types/backoffice/dto/subscriber-feedback/subscriber-feedback-allowed-form-dto.ts";
import { EInstallSatisfactionApplianceInstalledDto } from "@/types/backoffice/dto/survey/install-satisfaction/install-satisfaction-appliance-installed-dto.ts";

const subscriberFeedbackLocale = {
  subscriberFeedback: {
    title: "Remontées adhérents",
    subject: "Sujet",
    types: {
      [ESubscriberFeedbackFormType.ABUSE_REPORT]: "Signalement",
      [ESubscriberFeedbackFormType.INSTALL_SATISFACTION]: "Enquête de satisfaction",
    },
    abuse: {
      confirm: "Confirmer le signalement",
      type: "Personne visée par le signalement",
      appointment: "Date du RDV concernée par l'anomalie",
      reason: "Motif",
      abusiveReportType: {
        [EAbusiveReportType.INTERVENTION]: "Technicien",
        [EAbusiveReportType.VISIT]: "Opérateur Porte à Porte",
      },
    },
    installSatisfaction: {
      punctuality: "Ponctualité",
      cleanliness: "Propreté de l'installation",
      explanations: "Explications de la solution",
      friendliness: "Amabilité du technicien",
      professionalism: "Professionnalisme",
      rateTableHelp: "1: Insatisfait / 2: Pas satisfait / 3: Moyennement satisfait / 4: Satisfait / 5: Très satisfait",
      intervention: "Date d'intervention",
      applianceInstalledLabel:
        "Est-ce que tous vos appareils de chauffage (radiateurs et sèches-serviettes) ont bien été équipés ?",
      applianceInstalled: {
        [EInstallSatisfactionApplianceInstalledDto.TOTALLY]: "Oui en totalité",
        [EInstallSatisfactionApplianceInstalledDto.PARTIALLY_REQUESTED_BY_SUBSCRIBER]:
          "Partiellement, à la demande de l'adhérent",
        [EInstallSatisfactionApplianceInstalledDto.PARTIALLY_BY_TECHNICIAN]:
          "Partiellement, le technicien aurait dû les raccorder",
      },
      subscriberRecommendsSolutionLabel:
        "Fort de votre expérience actuelle, de la prise de rdv à l'installation de la solution, recommanderiez-vous la solution Voltalis à votre entourage ?",
      notPronounced: "Ne se prononce pas",
      doNotRecommend: "Je ne recommande pas du tout la solution Voltalis",
      recommend: "Je recommande sans hésitation la solution Voltalis",
      commentLabel:
        "Avez-vous un commentaire particulier concernant votre installation à nous partager ? Si tous les appareils de chauffage n'ont pas été équipés, pourquoi ?",
    },
  },
};

export type SubscriberFeedbackLocale = typeof subscriberFeedbackLocale;
export default subscriberFeedbackLocale;
